import React, { Component } from "react";
import dayjs from "dayjs";
import Icons from "Common/Icons";
import { CONSTANTS } from "utils/constant";
import utils from "utils";
import { connect } from "react-redux";
import { withTranslation , Trans} from "react-i18next";
import { PRIMARY_LANG } from "Common/constant";
import { LANG_STYLD_EXT } from "Common/constant";
import { TS_STYLD_COMPS } from "Common/constant";
import { t } from "i18next";
import icons from "Common/Icons";
import CommonButton from "./CommonButton";
import { Route, Switch, Link, Redirect, withRouter } from "react-router-dom";
import { message, Button } from "antd";
import PromptModal from "./PromptModal";
import DashboardIcon from "../assets/icons/new-icon-dashboard-appointment.svg";
import RightGreyArrow from '../assets/icons/chevron-right-grey.svg';
import { HeartHandIcon, HeartHandIconSmall } from "Common/ReactIcons";

import "./Styles/BackButton.scss";

export class Heading extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.GoToSwitchAccount = this.GoToSwitchAccount.bind(this);
      this.handleLogout = this.handleLogout.bind(this);
    this.openLogout = this.openLogout.bind(this);
  }
  

   GoToSwitchAccount = () => {
    this.props.history.push({
      pathname: "/logged-in-user/profile-lists",              
    });
  }

  handleNavigateAppointment = () =>{
     this.props.history.push({
      pathname: "/logged-in-user/consultation-history",              
    });
  }

    handleNavigateDashboard = () =>{
     this.props.history.push({
      pathname: "/logged-in-user/dashboard",              
    });
  }
  

 handleGoBack = () => {
        this.props.history.push({
            pathname: "/logged-in-user/consultation-history",
        })
    };

    handleGoBackCare = () => {
        this.props.history.push({
            pathname: "/logged-in-user/dashboard",
        })
    };

  handleLogout = (e) => {
  const tgtLang = this.props.includePrimeLang
    ? this.props.i18n.language + "_" + PRIMARY_LANG
    : this.props.i18n.language;
  utils.Modal(false);

  let keysToRemove = [
    "language",
    "subscription",
    "persist:root",
    "rzp_device_id",
    "isLoggedIn",
    "gender",
    "patient_id",
    "patient_user_type",
    "patient_gender",
    "phiReducer",
    "patient_type",
    "is_completed",
    "setGuestUUID",
    "qrRedirectData",
  ];

  for (let key of keysToRemove) {
    localStorage.removeItem(key);
  }

  message.success(t(CONSTANTS.LOGGED_OUT_SUCCESSFULLY, { lng: tgtLang }), 3);
  setTimeout(() => {
    message.destroy();
  }, 3000);

  this.props.logout();

  // if (
  //   process.env.REACT_APP_ENV != "dev" &&
  //   process.env.REACT_APP_ENV != "test"
  // )
  //   window.location.href = "https://www.ziloy.ai/";
};


openLogout = () => {
  const tgtLang = this.props.includePrimeLang
    ? this.props.i18n.language + "_" + PRIMARY_LANG
    : this.props.i18n.language;
  const tgtLangST = this.props.includePrimeLang ? tgtLang + LANG_STYLD_EXT : tgtLang;

  utils.Modal(true, {
    content: (
      <PromptModal
        title={<Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.LOGOUT_TITLE, { lng: tgtLangST })}</Trans>}
        content={<Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.LOGOUT, { lng: tgtLangST })}</Trans>}
        subContent={""}
        acptBtnLbl={<Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.YES, { lng: tgtLangST })}</Trans>}
        rejtBtnLbl={<Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.NO, { lng: tgtLangST })}</Trans>}
        rejtBtnType="link"
        rejtBtnClsName="link-button-green"
        onAccept={this.handleLogout.bind(this)}
        onReject={() => {
          this.setState((prevState) => ({
            selectedPath: prevState.selectedPath,
          }));
          utils.Modal(false);
        }}
        direction="vertical"
      />
    ),
    width: "500px",
  });
};

  render() {
    let { t } = this.props;
    const tgtLang = this.props.includePrimeLang
    ? this.props.i18n.language + "_" + PRIMARY_LANG
    : this.props.i18n.language;
    const tgtLangST = this.props.includePrimeLang
    ? tgtLang + LANG_STYLD_EXT
    : tgtLang;
    let patient_name = this.props?.data?.user_details?.first_name;
    let patient_last_name = this.props?.data?.user_details?.last_name;
    let patient_plan_name = this.props?.data?.user_details?.plan_name;
    let plan_valid_date = this.props?.data?.user_details?.plan_expiry_date;
    let active_plan = dayjs().isBefore(dayjs(plan_valid_date), "day") || dayjs().isSame(dayjs(plan_valid_date), "day");

 console.log("account_details:", this.props.account_details);
  console.log("user_details:", this.props.user_details);
    
    return (
      <>
        {this.props.data.location.pathname == "/logged-in-user/dashboard" && (
          <div className="new-heading">
{/* {(this.props?.user_details?.org_logo || this.props.location.pathname == "/logged-in-user/my-account") &&
 this.props.location.pathname != "/role-types/select-role" &&
 <div className="b2bcomlogo" >
   <img
   className="b2bcomlogoimg"
     src={this.props.account_details.org_logo}
   />
 </div>
} */}

            <span className="header">
              <Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.WELCOME_UAE,{lng:tgtLangST})}</Trans>{" "}
              {utils.FormatName(
                utils.getDisplayName(patient_name, patient_last_name)
              )}
            </span>
            {/* <span className="new-subheading">
            <Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.DASHBOARD_MESSAGE,{lng:tgtLangST})}</Trans>
            </span> */}
          </div>
        )}
        {(this.props.data.location.pathname ==
          "/logged-in-user/assessment-history" ||
          this.props.data.location.pathname ==
          "/logged-in-user/assessment" ||
          this.props.data.location.pathname ==
          "/logged-in-user/take-assessment/emotion" ||
          this.props.data.location.pathname ==
          "/logged-in-user/take-assessment/stress" ||
          this.props.data.location.pathname ==
          "/logged-in-user/take-assessment/senior_adult") && (
            <div className="new-heading">
              <span className="header">
                {/* <img className="new-heading-icon" src={Icons.assessment_header} />{" "} */}
                <Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.ASSESSMENT_TABLE,{lng:tgtLangST})}</Trans>
              </span>
              <span className="new-subheading">
              <Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.ASSESSMENT_HEADER,{lng:tgtLangST})}</Trans>
              </span>
            </div>
          )}
        {/* {this.props.data.location.pathname ==
          "/logged-in-user/score-details" && (
          <div className="new-heading">
            <span className="header">
              <img className="new-heading-icon" src={Icons.pie_chart_header} />{" "}
              {CONSTANTS.YOUR_RESULTS}
            </span>
            <span className="new-subheading">
              {this.props.assessment_question_type =="emotion"  ?
               CONSTANTS.ASSESSMENT_RESULT_HEADER:
               this.props.assessment_question_type=="stress"?
               CONSTANTS.ASSESSMENT_STRESS_HEADER: CONSTANTS.ASSESSMENT_GERIATRIC_HEADER
          }
            </span>
          </div>
        )} */}
        {((this.props?.user_details?.is_profile_completed || this.props?.user_details.org_type == "individual") && this.props.data?.location?.pathname == "/logged-in-user/preferred-clinician") &&
        <div className="heading-back">
           <Button className="back-btn-without-background careteam-back" onClick={()=> this.handleGoBack()} icon={<img src={Icons.back_arrow_small}/>}>
        { <Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.BACK,{lng:tgtLangST})}</Trans>}
    </Button>
       
          <div className="new-heading">
{/* <BackButtonEmptyBackground onClick = {() => this.handleGoBack()}  /> */}

            {/* <BackButtonEmptyBackground/> */}
            <span className="header care-head">
            <Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.CARE_TEAM_FOR_U,{lng:tgtLangST})}</Trans>
            </span>
            <span className="new-subheading care-head-sub">
            <Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.CARE_TEAM_HERE,{lng:tgtLangST})}</Trans>
            </span>
          </div>
           </div>
        }
        {(this.props.data.location.pathname ==
          "/logged-in-user/schedule-appointment" ||
          this.props.data.location.pathname ==
          "/logged-in-user/select-doctor" ||
          this.props.data.location.pathname ==
          "/logged-in-user/consultation-history") && (
            <div className="new-heading">
              <span className="header">
                {/* <img
                className="new-heading-icon"
                src={Icons.schedule_appointment_header}
              />{" "} */}
                <Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.APPOINTMENT,{lng:tgtLangST})}</Trans>
              </span>
              <span className="new-subheading">
              <Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.APPOINTMENT_HEADER,{lng:tgtLangST})}</Trans>
              </span>
            </div>
          )}
           {(this.props.data.location.pathname ==
          "/logged-in-user/appointment-details"  &&
            <div className="new-heading">
            <div className="breadcrumb-navigation">
                  <div className="breadcrumb-home">
                    <div className="breadcrumb-home-div" onClick={() => this.handleNavigateDashboard()}>
                      <img src={DashboardIcon}></img>
                      </div>
                    <img src={RightGreyArrow}></img>
                  </div>
                  <div className="breadcrumb-appointment">
                    <div className="breadcrumb-home-div"  onClick={() => this.handleNavigateAppointment()}
>
                    <Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.APPOINTMENT,{lng:tgtLangST})}</Trans>
                    </div>
                    <img src={RightGreyArrow}></img>
                  </div>
                  <div className="breadcrumb-detail">
                    <Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.APPOINTMENT_DETAIL,{lng:tgtLangST})}</Trans>
                  </div>
                </div>
             <div> 
              <span className="header">
                {/* <img
                className="new-heading-icon"
                src={Icons.schedule_appointment_header}
              />{" "} */}
                <Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.APPOINTMENT_DETAIL,{lng:tgtLangST})}</Trans>
              </span>
             </div>  
              <span className="new-subheading">
              <Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.APPOINTMENT_DETAIL_HEADER,{lng:tgtLangST})}</Trans>
              </span>
            
            </div>
          )}



        {(this.props.data.location.pathname ==
          "/logged-in-user/subscription-plan") && (
                <div className="heading-back">
               <Button className="back-btn-without-background careteam-back" onClick={()=> this.handleGoBackCare()} icon={<img src={Icons.back_arrow_small}/>}>
        { <Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.BACK,{lng:tgtLangST})}</Trans>}
    </Button>
        
            <div className="new-heading care-without-pad">
              
              <span className="header care-head">
                {/* <img
                className="new-heading-icon"
                src={Icons.subscription_header}
              />{" "} */}
                <Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.CARE_PLAN_B2B,{lng:tgtLangST})}</Trans>
              </span>
              <span className="new-subheading care-head-sub">
              <Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.SUBSCRIPTION_HEADER,{lng:tgtLangST})}</Trans>
              </span>
            </div>
            </div>
          )}




        {this.props.data.location.pathname ==
          "/logged-in-user/health-profile" && (
                <div className="heading-back">
               <Button className="back-btn-without-background careteam-back health-back" onClick={()=> this.handleGoBackCare()} icon={<img src={Icons.back_arrow_small}/>}>
        { <Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.BACK,{lng:tgtLangST})}</Trans>}
    </Button>
            <div className="new-heading">
              <span className="header">
                {/* <img
                className="new-heading-icon"
                src={Icons.health_info_header}
              />{" "} */}
                <Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.HEALTH_RECORD,{lng:tgtLangST})}</Trans>
              </span>
              <span className="new-subheading ">
              <Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.HEALTH_INFORMATION_HEADER,{lng:tgtLangST})}</Trans>
              </span>
            </div>
            </div>
          )}
        {this.props.data.location.pathname ==
          "/logged-in-user/document-upload" && (
            <div className="new-heading">
              <span className="header">
                {/* <img
                className="new-heading-icon"
                src={Icons.document_upload_header}
              />{" "} */}
                <Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.DOCUMENT_UPLOAD,{lng:tgtLangST})}</Trans>
              </span>
              <span className="new-subheading">
              <Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.DOCUMENT_UPLOAD_HEADER_2,{lng:tgtLangST})}</Trans>
              </span>
            </div>
          )}
        {this.props.data.location.pathname == "/logged-in-user/my-order" && (
          <div className="new-heading">
            <div className="header" style={{display: "flex", justifyContent: "space-between"}}>
              {/* <img className="new-heading-icon" src={Icons.my_orders_header} />{" "} */}
              <Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.MY_ORDERS,{lng:tgtLangST})}</Trans>
              <CommonButton
                className="view-care-plan my-order-large"
                label={<div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "12px" }}>
                  <div><HeartHandIcon /></div><div>{t(CONSTANTS.VIEW_CARE_PLANS, { lng: tgtLang })}</div></div>}
                onClick={() => this.props.history.push("/logged-in-user/subscription-plan")}
              /> 
            </div>
            <span className="new-subheading ">
            <Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.MY_ORDERS_HEADER,{lng:tgtLangST})}</Trans>
            </span>

            
          </div>
        )}
        {/* {(this.props.data.location.pathname == "/logged-in-user/profile-lists" ||this.props.data.location.pathname == "/logged-in-user/pathway-process" )&& (
          <div className="new-heading">
            <span className="header">
              <img className="new-heading-icon" src={Icons.switch_account_header} />{" "}
              {CONSTANTS.SWITCH_ACCOUNT}
            </span>
            <span className="new-subheading">{CONSTANTS.CHOOSE_A_PROFILE}</span>
          </div>
        )} */}
        {(this.props.data.location.pathname ==
          "/logged-in-user/my-account-child" ||
          this.props.data.location.pathname ==
          "/logged-in-user/my-account") && (
            <div className="align-profile-bar">
            <div className="new-heading">
              <span className="header">
              <Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.MY_PROFILE,{lng:tgtLangST})}</Trans>
              </span>
              <span className="new-subheading">
              <Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.MY_PROFILE_HEADING_MESSAGE,{lng:tgtLangST})}</Trans>
              </span>
            </div>
                <div className="align-logout-switch">
                          <CommonButton
                            className="profile-logout-button"
                            icon={<img className="add-dependant-icon" src={icons.logout} alt="Settings" />}
                            label={t(CONSTANTS.LOGOUT_TITLE, { lng: tgtLang })}
                        //  onClick={this.openLogout.bind(this)}
                        onClick={this.openLogout.bind(this)}
                          /> 
                            <CommonButton
                            className="profile-switch-button"
                            icon={
                              <> 
                            <img
                             className="add-dependant-icon large_switch_icon" 
                             src={icons.Switch_user} 
                             alt="new_member" 
                             /> 
                               <img
                             className="add-dependant-icon small_switch_icon" 
                             src={icons.Switch_user_small} 
                             alt="new_member" 
                             /> 
                             </>
                            }
                            onClick={() => this.GoToSwitchAccount()}
                            label={t(CONSTANTS.SWITCH_ACCOUNT, { lng: tgtLang })}
                             />
                        </div>
            </div>
          )}
      </>
    );
  }
}

const MapStateToProps=(state)=>{
  return{
    assessment_question_type: state.assessmentReducer.headingQuestionType,
    includePrimeLang: state.loginReducer.includePrimeLang,
    account_details: state.loginReducer.account_details, // Add this line
    user_details: state.loginReducer.user_details, // Add this line
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch({ type: "USER_LOGOUT" }),
  };
};
export default withRouter(connect(MapStateToProps, mapDispatchToProps)(withTranslation()(Heading)));

